import { combineReducers } from "redux";
import { session } from "./sessionReducer";

const authReducers = combineReducers({
  session,
});

export default authReducers;
